import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

const IncomingBanksLoanRepaymentDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Row>
      <Col sm={6}>
        <NFLookupBankAccount fieldName="senderBankAccountId" title={t("SenderBankAccount")} required />
      </Col>
      <Col sm={6}>
        <NFLookupInput fieldName="amountType" title={t("AmountType")} items={EnumHelper.GetPrincipalOperationType()} required />
      </Col>
    </Row>
  );
};

export default IncomingBanksLoanRepaymentDetail;
